export default __webpack_public_path__ + "static/media/unionpay.f3c915b0.svg";